import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Star, Users, Sparkles, ArrowUpRight } from "lucide-react";
import api, { cachedGet } from "../lib/api";

const TONE = {
  blue: { bar: "#2563EB", text: "text-[#2563EB]", chip: "bg-[#DBEAFE]" },
  amber: { bar: "#B45309", text: "text-[#B45309]", chip: "bg-[#FEF3C7]" },
  red: { bar: "#DC2626", text: "text-[#DC2626]", chip: "bg-[#FEE2E2]" },
};

export function useSubscription() {
  const [sub, setSub] = useState(null);
  useEffect(() => { cachedGet("/subscription").then((r) => setSub(r.data)).catch(() => {}); }, []);
  return sub;
}

export default function SubscriptionWidget({ onUpgrade }) {
  const navigate = useNavigate();
  const sub = useSubscription();
  if (!sub) return null;
  const plan = sub.governing_plan || sub.plan;

  if (plan === "free") {
    return (
      <div data-testid="subscription-widget" className="rounded-2xl border border-[#EBECE8] p-4">
        <div className="flex items-center gap-2"><Sparkles className="h-4 w-4 text-[#0F766E]" strokeWidth={2} /><span className="text-sm font-semibold text-[#2D3436]">Free Plan</span></div>
        <div className="mt-0.5 text-xs text-[#636E72]">Unlock unlimited records & reminders.</div>
        <button data-testid="widget-upgrade-btn" onClick={() => (onUpgrade ? onUpgrade() : navigate("/app/billing"))} className="mt-3 flex w-full items-center justify-center gap-1.5 rounded-lg bg-[#0F766E] px-3 py-2 text-xs font-medium text-white hover:-translate-y-0.5 transition-transform">
          Upgrade <ArrowUpRight className="h-3.5 w-3.5" />
        </button>
      </div>
    );
  }

  const isFamily = plan === "family";
  return (
    <div data-testid="subscription-widget" className={`rounded-2xl border p-4 ${isFamily ? "border-[#7C3AED]/20 bg-[#7C3AED]/5" : "border-[#0F766E]/20 bg-[#0F766E]/5"}`}>
      <div className="flex items-center gap-2">
        {isFamily ? <Users className="h-4 w-4 text-[#7C3AED]" strokeWidth={2} /> : <Star className="h-4 w-4 text-[#0F766E]" strokeWidth={2} />}
        <span className="text-sm font-semibold text-[#2D3436]">{isFamily ? "Family" : "Premium"} Plan</span>
      </div>
      <button data-testid="widget-manage-btn" onClick={() => navigate("/app/billing")} className="mt-2 text-xs font-medium text-[#0F766E] hover:underline">Manage subscription</button>
    </div>
  );
}
